import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { ConfigurationContext } from '../../../ContextProviders/ConfigurationProvider';
import useConfigurationChanges from '../../../Hooks/useConfigurationChanges';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { findByEmbeddedOptionIdentifier, getEmbeddedOptionIdentifier } from '../../../Selectors/Option';
import { useTranslation } from 'react-i18next';
import { isPVCRoof } from '../../../DataStructures/roofTypes';
import ConfirmDialog from '../../../ConfirmDialog';
import DialogContentDivider from '../../DialogContentDivider';
import useItemRules from '../../../Rules/useItemRules';
import Typography from '@material-ui/core/Typography';
import HintPopup from '../../HintPopup';

export const Walls = () => {
  const { t } = useTranslation();

  const configuration = useContext(ConfigurationContext);
  const {
    localOptions: { walls: wallTypes, wall_triangle: gableTypes },
  } = useSelector((state) => state.Option);
  const { setWallType, setGableType } = configuration;
  const { wallType, gableType } = useConfigurationChanges(configuration);
  const [confirmState, setConfirmState] = useState({ show: false, value: null });
  const [hintKey, setHintKey] = useState('');

  const onClose = () => setConfirmState({ show: false });
  const onConfirm = () => {
    setWallType(findByEmbeddedOptionIdentifier(wallTypes, confirmState.value));
    setConfirmState({ show: false, value: null });
  };

  const onWallTypeChange = ({ target: { value } }) => {
    if (value === 'wall_type_pvc' && !isPVCRoof(configuration.getData().roofType)) {
      setConfirmState({ show: true, value });
      return;
    }
    if (value === 'no_wall_cladding') {
      setHintKey('extraHints.noWallCladdingSelected');
    }
    setWallType(findByEmbeddedOptionIdentifier(wallTypes, value));
  };

  const onGableTypeChange = ({ target: { value } }) => {
    setGableType(findByEmbeddedOptionIdentifier(gableTypes, value));
  };

  const rules = useItemRules();

  return (
    <>
      <ConfirmDialog
        open={confirmState.show}
        content={t('pvcHallDialog.invalidWallType')}
        onConfirm={onConfirm}
        onClose={onClose}
        confirmButtonLabel={t('pvcHallDialog.confirm')}
      />
      <HintPopup
        open={!!hintKey}
        onClose={() => setHintKey('')}
        anchorPosition={{ top: window.innerHeight * 0.5, left: window.innerWidth * 0.4 }}
      >
        <Typography>{t(hintKey)}</Typography>
      </HintPopup>
      <RadioGroup
        aria-label="wall type"
        value={getEmbeddedOptionIdentifier(wallType)}
        onChange={onWallTypeChange}
      >
        {wallTypes.map(({ option: { identifier, title } }) => (
          <FormControlLabel
            key={identifier}
            value={identifier}
            control={<Radio />}
            label={title}
            disabled={rules.disabledWallTypes?.includes(identifier)}
          />
        ))}
      </RadioGroup>
      {!!gableTypes.length && (
        <>
          <DialogContentDivider />
          <RadioGroup
            aria-label="roof type"
            value={getEmbeddedOptionIdentifier(gableType)}
            onChange={onGableTypeChange}
          >
            {gableTypes.map(({ option: { identifier, title } }) => (
              <FormControlLabel key={identifier} value={identifier} control={<Radio />} label={title} />
            ))}
          </RadioGroup>
        </>
      )}
    </>
  );
};

export default Walls;
